import { gql } from '@apollo/client'

export const GET_USER_IDENTITY = gql`
  query getUserIdentity {
    loggedInUser {
      id
      avatar
      isPhoneVerified
      isEmailVerified
      locationCountryCode
      cart {
        id
      }
      selectedPayoutMethod {
        name
      }
      knowYourCustomer {
        status
      }
      consent {
        id
        type
        hasGivenConsent
      }
      createdAt
    }
  }
`
